export const SPACE_3XS = 2;
export const SPACE_XS = 4;
export const SPACE_SM = 8;
export const SPACE_MD = 12;
export const SPACE_LG = 16;
export const SPACE_XL = 24;
export const SPACE_2XL = 32;
export const SPACE_3XL = 40;
export const SPACE_4XL = 48;
